import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SurveyMaster from '../views/SurveyContentsMaster.vue'
import SurveyFinance from '../views/SurveyContentsFinance.vue'
import SurveyLife from '../views/SurveyContentsLife.vue'
import SurveyCareer from '../views/SurveyContentsCareer.vue'
import SurveyAction from '../views/SurveyContentsAction.vue'
import Login from '../views/Login.vue'
import store from '../store'
import _Default from '@/layouts/Default'
import _Blank from '@/layouts/Blank'
Vue.use(VueRouter)
function requireUserName(to, from, next) {
  if (store.state.userEmail === '' || store.state.userNick === '' || store.state.classId === '' || store.state.className === '') {
    alert('사용자 정보나 클래스정보가 없습니다.  첫화면으로 돌아갑니다')
    next({
      path: '/',
    })
  } else {
    next()
  }
}
function requireAnswer(to, from, next) {
  if (to.name === 'masterScoreSheet' && !store.state.master['커리어-likert-9']) {
    alert('마스터 설문이 완료되지 않았습니다')
    next({
      path: '/' + store.state.classId + '/master',
    })
  } else if (!store.state.me.birthAt) {
    alert('설문이 완료되지 않았습니다')
    next({
      path: '/' + store.state.classId + '/master',
      // query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
}
const routes = [
  {
    path: '/summary',
    name: 'Summary',
    component: _Blank,
    beforeEnter: requireAnswer,
    children: [
      {
        path: ':classId',
        name: 'All',
        component: () => import('../views/summary/All.vue'),
      },
      {
        path: ':classId/overview',
        name: 'Overview',
        component: () => import('../views/summary/Overview.vue'),
      },
      {
        path: ':classId/lifedesign',
        name: 'LifeDesign',
        component: () => import('../views/summary/LifeDesign.vue'),
      },
      {
        path: ':classId/family',
        name: 'Family',
        component: () => import('../views/summary/Family.vue'),
      },
      {
        path: ':classId/finance',
        name: 'Finance',
        component: () => import('../views/summary/Finance.vue'),
      },
      {
        path: ':classId/career',
        name: 'Career',
        component: () => import('../views/summary/Career.vue'),
      },
      {
        path: ':classId/action',
        name: 'Action',
        component: () => import('../views/summary/Action.vue'),
      },
    ],
  },
  {
    path: '/survey',
    name: 'Survey',
    component: _Default,
    redirect: '/survey/introduction',
    children: [
      {
        path: 'introduction',
        name: 'Introduction',
        component: () => import('../views/survey/Introduction.vue'),
      },
      {
        path: 'start',
        name: 'Start',
        component: () => import('../views/survey/SurveyContents.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: _Default,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
      },
      {
        path: '/:classId/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/:classId/master',
        name: 'master',
        component: SurveyMaster,
        beforeEnter: requireUserName,
      },
      {
        path: '/:classId/finance',
        name: 'finance',
        component: SurveyFinance,
        beforeEnter: requireUserName,
      },
      {
        path: '/:classId/life',
        name: 'life',
        component: SurveyLife,
        beforeEnter: requireUserName,
      },
      {
        path: '/:classId/career',
        name: 'career',
        component: SurveyCareer,
        beforeEnter: requireUserName,
      },
      {
        path: '/:classId/action',
        name: 'action',
        component: SurveyAction,
        beforeEnter: requireUserName,
      },

      {
        path: '/:classId/score/master',
        name: 'masterScoreSheet',
        component: () => import('../views/scoreSheetMaster'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/finance',
        name: 'financeScoreSheet',
        component: () => import('../views/scoreSheetFinance'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/finance2',
        name: 'financeScoreSheet2',
        component: () => import('../views/scoreSheetFinance2'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/life',
        name: 'lifeScoreSheet',
        component: () => import('../views/scoreSheetLife'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/career',
        name: 'careerScoreSheet',
        component: () => import('../views/scoreSheetCareer'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/career2',
        name: 'careerScoreSheet2',
        component: () => import('../views/scoreSheetCareer2'),
        beforeEnter: requireAnswer,
      },
      {
        path: '/:classId/score/action',
        name: 'actionScoreSheet',
        component: () => import('../views/scoreSheetAction'),
        beforeEnter: requireAnswer,
      },
    ],
  },
]

const router = new VueRouter({
  routes,
})

export default router
